exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{font-family:Oxygen,sans-serif}body{padding:0;margin:0}.app,body{height:100%;width:100%}.app{position:fixed;display:flex}.content{display:flex;flex-direction:column;flex:1 1 auto;background-color:#f8f9fa;min-width:0}.demo{flex:1;overflow:auto;min-width:0}.wide-page{margin:50px auto;padding:0 50px}.simple-page{max-width:500px;margin:50px auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/layout.css
// module id = 33
// module chunks = 0